module.exports = __webpack_public_path__ + "img/hand-holding-phone-icon.svg";